const Facebook = (props) => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='#152a46'
    {...props}
    className={props?.color}
  >
    <path d='M34.141,5.859A19.269,19.269,0,0,0,20,0,19.269,19.269,0,0,0,5.859,5.859,19.269,19.269,0,0,0,0,20,19.269,19.269,0,0,0,5.859,34.141,19.269,19.269,0,0,0,20,40a19.269,19.269,0,0,0,14.141-5.859A19.269,19.269,0,0,0,40,20,19.269,19.269,0,0,0,34.141,5.859ZM25.156,20H21.875V32.031H17.422V20H14.375V15.859h3.047V13.438a6.85,6.85,0,0,1,1.016-4.1q1.016-1.367,3.828-1.367h3.281v4.141H23.516q-1.094,0-1.367.391a2.4,2.4,0,0,0-.273,1.328v2.031h3.75ZM40,37.5' />
    <style jsx>
      {`
        .UA {
          fill: rgb(255, 69, 9) !important;
        }
      `}
    </style>
  </svg>
)

export default Facebook
